angular
  .module('contrast.services.saml', [])
  .factory(
    'SAMLService',
    function ($, $q, $translate, AuthFactory, CommonFactory) {
      'ngInject'

      var me = this
      me.samlMetadata = null
      me.samlMetadataPromise = null

      angular.extend(me, {
        metadata: {
          data: null,
          promise: null
        },
        publicMetadata: {
          data: null,
          promise: null
        },
        settings: {
          data: null,
          promise: null
        }
      })

      return {
        getSPMetadata: getSPMetadata,
        transformConfig: transformConfig,
        transformSecretConfig: transformSecretConfig,
        transformSecretConfigForSaving: transformSecretConfigForSaving,
        transformSamlConfig: transformSamlConfig,
        getPublicSPMetadata: getPublicSPMetadata
      }

      function transformConfig(hasMetadataUrl, config) {
        var domains = [],
          groupId,
          roleId,
          organizationUuid,
          provisioningEnabled = config.provisioning_enabled,
          autoAddToGroupEnabled = config.auto_add_to_group_enabled,
          autoRemoveFromGroupEnabled = config.auto_remove_from_group_enabled
        if (provisioningEnabled) {
          domains = _.map(config.domains, 'value')
        }
        groupId = config.group.group_id
        roleId = config.role.group_id
        organizationUuid = config.organization
          ? config.organization.organization_uuid
          : ''

        var response = {
          saml: {
            identity_provider_name: config.identity_provider_name,
            provider_key: config.provider_key,
            provisioning_enabled: provisioningEnabled,
            auto_add_to_group_enabled: autoAddToGroupEnabled,
            auto_remove_from_group_enabled: autoRemoveFromGroupEnabled,
            ac_group_id: groupId,
            ac_roles_id: roleId,
            organization_uuid: organizationUuid,
            domains: domains,
            default_rbac_user_access_group_id:
              config.default_rbac_user_access_group_id
          }
        }

        if (hasMetadataUrl) {
          response.saml.metadata_url = config.metadata_url
        } else {
          response.saml.metadata_xml = config.metadata_xml
        }

        return response
      }

      function transformSecretConfig(hasMetadataUrl, config) {
        if (hasMetadataUrl) {
          return {
            secret_node_saml: {
              identity_provider_name: config.identity_provider_name,
              metadata_url: config.metadata_url,
              provider_key: config.provider_key
            }
          }
        } else {
          return {
            secret_node_saml: {
              identity_provider_name: config.identity_provider_name,
              metadata_xml: config.metadata_xml,
              provider_key: config.provider_key
            }
          }
        }
      }

      function transformSecretConfigForSaving(
        hasMetadataUrl,
        config,
        secretConfig
      ) {
        var domains = [],
          groupId,
          roleId,
          organizationUuid,
          provisioningEnabled = config.provisioning_enabled,
          autoAddToGroupEnabled = config.auto_add_to_group_enabled,
          autoRemoveFromGroupEnabled = config.auto_remove_from_group_enabled

        if (provisioningEnabled) {
          domains = _.map(config.domains, 'value')
        }
        groupId = config.group.group_id
        roleId = config.role.group_id
        organizationUuid = config.organization
          ? config.organization.organization_uuid
          : ''

        var response = {
          secret_node_saml: {
            identity_provider_name: secretConfig.identity_provider_name,
            provider_key: secretConfig.provider_key,
            provisioning_enabled: provisioningEnabled,
            auto_add_to_group_enabled: autoAddToGroupEnabled,
            auto_remove_from_group_enabled: autoRemoveFromGroupEnabled,
            ac_group_id: groupId,
            ac_roles_id: roleId,
            organization_uuid: organizationUuid,
            domains: domains
          }
        }

        if (hasMetadataUrl) {
          response.secret_node_saml.metadata_url = secretConfig.metadata_url
        } else {
          response.secret_node_saml.metadata_xml = secretConfig.metadata_xml
        }

        return response
      }

      function transformSamlConfig(
        hasMetadataUrl,
        config,
        hasSecretMetadataUrl,
        secretConfig
      ) {
        return angular.extend(
          transformConfig(hasMetadataUrl, config),
          transformSecretConfigForSaving(
            hasSecretMetadataUrl,
            config,
            secretConfig
          )
        )
      }

      function getSPMetadata() {
        var deferred = $q.defer()

        if (me.metadata.data) {
          deferred.resolve(me.metadata.data)
        } else if (me.metadata.promise != null) {
          me.metadata.promise.then(function (data) {
            deferred.resolve(me.metadata.data)
            return data
          })
        } else {
          me.metadata.promise = AuthFactory.getSAMLMetadata().then(function (
            response
          ) {
            me.metadata.data = parseMetadata(response.data)
            deferred.resolve(me.metadata.data)
            return me.metadata.data
          })
        }

        return deferred.promise
      }

      function getPublicSPMetadata() {
        if (me.publicMetadata.data) {
          return $q.when(me.publicMetadata.data)
        } else if (me.publicMetadata.promise != null) {
          return me.publicMetadata.promise
        } else {
          return (me.publicMetadata.promise =
            CommonFactory.getPublicSAMLMetadata().then(function (response) {
              me.publicMetadata.data = parseMetadata(response.data)
              return me.publicMetadata.data
            }))
        }
      }

      function parseMetadata(data) {
        var transl = {
          detail_noneRequired_attributes: $translate.instant(
            'detail_noneRequired_attributes'
          ),
          title_emailAddress: $translate.instant('title_emailAddress')
        }

        var xmlData = $.parseXML(data),
          xml = $(xmlData),
          entityDescriptor = getElement(xml, 'EntityDescriptor', 'md'),
          assertionConsumerService = getElement(
            xml,
            'AssertionConsumerService',
            'md'
          )
        return {
          entityId: $(entityDescriptor).attr('entityID'),
          metadataUrl: $(entityDescriptor).attr('entityID'),
          asserionConsumerUrl: $(assertionConsumerService).attr('Location'),
          consumerBinding: 'HTTP-POST',
          version: '2.0',
          nameIdFormat: transl.title_emailAddress,
          attributes: transl.detail_noneRequired_attributes
        }
      }

      function getElement(xml, name, namespace) {
        if (!namespace) {
          return xml.find(name)
        } else {
          return $(namespace + '\\:' + name + ', ' + name, xml)
        }
      }
    }
  )
